import cx from 'classnames';

export class PaymentType {
  static readonly CASH = { name: 'Cash', key: 'cash' };
  static readonly CARD = { name: 'Card', key: 'card' };
  static readonly PAPER_CHECK = { name: 'Paper Check', key: 'paper_check' };
  static readonly RELAY = { name: 'Relay code', key: 'code' };
  static readonly REMOTE_CHECKOUT = { name: 'Remote Checkout', key: 'remote checkout' };
  static readonly DIRECT_BILL = { name: 'Direct Bill', key: 'direct_bill' };
}

const paymentTypeNames = [
  PaymentType.CASH,
  PaymentType.CARD,
  PaymentType.PAPER_CHECK,
  PaymentType.RELAY,
  PaymentType.REMOTE_CHECKOUT,
  PaymentType.DIRECT_BILL,
];

export const getFilteredPaymentTypeNames = (disablePaymentTypes: Array<string>) => {
  return paymentTypeNames.filter(type => !disablePaymentTypes || !Array.isArray(disablePaymentTypes)
    || !disablePaymentTypes.includes(type.key));
}

const paymentTypeSearchNames = [
  { name: 'Comchek', key: 'comchek' },
  { name: 'EFS', key: 'efs' },
  { name: 'FleetOne', key: 'fleet_one' },
  { name: 'T-Chek', key: 't_chek' },
  { name: 'Instamoney', key: 'instamoney' },
  PaymentType.RELAY,
  PaymentType.REMOTE_CHECKOUT,
  PaymentType.CASH,
  PaymentType.CARD,
  PaymentType.PAPER_CHECK,
  PaymentType.DIRECT_BILL,
];

export const getPaymentName = (paymentType) => {
  const paymentName = paymentTypeSearchNames.find(i => paymentType === i.key);

  if (!paymentName) {
    if (paymentType && paymentType !== '') return paymentType;
    return 'Unknown';
  }
  return paymentName.name;
};

export class SaleStatus {
  static readonly NEW = { name: 'New', key: 'new' };
  static readonly PAYMENT_PROCESSING = { name: 'Processing', key: 'payment_processing' };
  static readonly PAYMENT_FAILED = { name: 'Failed', key: 'payment_failed' };
  static readonly COMPLETED = { name: 'Completed', key: 'completed' };
}

export const getSaleStatus = (saleStatusKey: string) => {
  const status = Object.values(SaleStatus).find(v => v.key === saleStatusKey);

  if (!status) return null;
  return status;
}

export const getSaleStatusName = (saleStatusKey: string) => {
  const status = Object.values(SaleStatus).find(v => v.key === saleStatusKey);

  if (!status) return null;
  return status.name;
}

export const getSaleStatuses = () => {
  return Object.values(SaleStatus);
}

export const isRemoteCheckout = (paymentType: string) => {
  return paymentType === PaymentType.REMOTE_CHECKOUT.key;
}

export const isSaleEditable = (saleStatus: string, paymentType: string, paymentId: string) => {
  const remoteCheckout = isRemoteCheckout(paymentType);

  return (saleStatus === SaleStatus.NEW.key &&
    (!paymentType || remoteCheckout || paymentType === PaymentType.RELAY.key)
  ) || (saleStatus === SaleStatus.PAYMENT_FAILED.key && !remoteCheckout);
}

export const isSaleDeletable = (saleStatus: string, paymentType: string) => {
  return (saleStatus === SaleStatus.NEW.key || saleStatus === SaleStatus.PAYMENT_FAILED.key
    || (saleStatus === SaleStatus.PAYMENT_PROCESSING.key && paymentType === PaymentType.REMOTE_CHECKOUT.key));
}

export const getStatusClasses = (status) => {
  return cx('btn btn--sm', {
    'btn--prim': status === SaleStatus.COMPLETED.key,
    'btn--warn': status === SaleStatus.PAYMENT_FAILED.key,
    'btn--lgry': status === SaleStatus.NEW.key,
    'btn--yell': status === SaleStatus.PAYMENT_PROCESSING.key,
  });
};
